import { Errors, panic, tryCatch } from "@opendaw/lib-std";
// Deleting for good is the one decision that has to reach every device, so the tombstones travel while the
// trash stays home. The union only grows here: a device that has been offline for months must not resurrect
// what the others deleted.
export var CloudBackupTombstones;
(function (CloudBackupTombstones) {
    CloudBackupTombstones.FileName = "tombstones.json";
    CloudBackupTombstones.sync = async (cloudHandler, remotePath, local, log) => {
        const path = `${remotePath}/${CloudBackupTombstones.FileName}`;
        const remote = await cloudHandler.download(path)
            .then(bytes => parse(bytes))
            .catch(reason => reason instanceof Errors.FileNotFound ? [] : panic(reason));
        const union = Array.from(new Set([...remote, ...local]));
        if (union.length > local.length || union.length > remote.length) {
            log("Syncing deletions...");
            await cloudHandler.upload(path, new TextEncoder().encode(JSON.stringify(union)).buffer);
        }
        return union;
    };
    const parse = (bytes) => {
        const result = tryCatch(() => JSON.parse(new TextDecoder().decode(bytes)));
        return result.status === "success" && Array.isArray(result.value) ? result.value : [];
    };
})(CloudBackupTombstones || (CloudBackupTombstones = {}));
